import { cn } from "@/lib/utils";

/** Small status marker: a coloured dot plus a label. Colour never carries the meaning alone. */
export function StatusDot({ tone, children, className }: { tone: "open" | "done" | "neutral"; children: React.ReactNode; className?: string }) {
  return (
    <span className={cn("inline-flex min-w-0 items-center gap-1.5", tone === "open" ? "text-foreground" : "text-muted-foreground", className)}>
      <span aria-hidden className={cn("size-1.5 shrink-0 rounded-full", tone === "open" ? "bg-warning" : tone === "done" ? "bg-muted-foreground/50" : "bg-border")} />
      <span className="truncate">{children}</span>
    </span>
  );
}
